import { CustomersV2Layout } from './CustomersV2Layout';
import { useGetSharedFunctionality } from '../../api/lending/lapiHooks';
import { LoadingScreen } from '../../components/LoadingScreen/LoadingScreen';
import { isDemoModeEnabled } from '../../demo/utils/isDemoModeEnabled';
import { Customers } from '../Customers/Customers';

export const CustomersRouteElement = () => {
  const { functionality, loadingFunctionality } = useGetSharedFunctionality({
    functionalities: ['use_new_customers_page'],
  });

  // The demo mocks only the legacy customers endpoint, and everything else is
  // blocked, so the new page cannot load its data inside a demo session.
  if (isDemoModeEnabled()) return <Customers />;

  if (loadingFunctionality) return <LoadingScreen />;

  return functionality?.use_new_customers_page ? (
    <CustomersV2Layout />
  ) : (
    <Customers />
  );
};
